<script>

import { onMount } from 'svelte';
import ColorUtils, { rgbToString } from './ColorUtils.svelte';
import { onDestroy } from 'svelte';


import { currentColor } from '../stores';
import { opacity } from '../stores';
import { brushSize } from '../stores';

import { pickingFromCanvas } from '../stores';

let safeToUpdate = false;



let colorPickerInstance;


let sliderInst;

let sideBar;


let colorPreview;




function updateOpacity(event){
    opacity.set(sliderInst.value);
    pickingFromCanvas.set(false);

}

function updateSize(newSize){
    brushSize.set(newSize);
    pickingFromCanvas.set(false);

}

function updateColorPreview(){
    colorPreview.style.backgroundColor = rgbToString($currentColor[0],$currentColor[1],$currentColor[2]);
}



//color picker stuff

let ctx;

onMount(async () => {
        ctx = colorPickerInstance.getContext("2d", {alpha: !1});
        resizeToHolder();
        updateColorPreview();
        safeToUpdate = true;
});

let currentDim = 0;

function resizeToHolder(){

    currentDim = sideBar.clientWidth;

    colorPickerInstance.width = currentDim;
    colorPickerInstance.height = currentDim * 1.075;

    drawColorGrid();
 }

 function drawColorGrid(){
    ctx.clearRect(0,0, currentDim, currentDim);
    ctx.fillStyle = "white", ctx.fillRect(0, 0, currentDim, currentDim);
    //top of the slider
    fillTopSide();
    fillUnderSide($currentColor[0], $currentColor[1], $currentColor[2]);
}




function fillTopSide() {
    let color_array = [255, 0, 0];
    let color_slide = [];

    for (let i = 0; i < 6; i++)
        for (let x = 0; x < 255; x++) {
            switch (i) {
                case 0:
                    color_array[1] += 1;
                    break;
                case 1:
                    color_array[0] -= 1;
                    break;
                case 2:
                    color_array[2] += 1;
                    break;
                case 3:
                    color_array[1] -= 1;
                    break;
                case 4:
                    color_array[0] += 1;
                    break;
                case 5:
                    color_array[2] -= 1;
            }
            let color_to_set = [color_array[0], color_array[1], color_array[2]];
            color_slide.push(color_to_set);
        }
    let point_on_canvas = 0;

    let steps_to_take = currentDim;
    let toAddToPick = color_slide.length / currentDim;

    for (let i = 0; i < steps_to_take; i++) {
        let current_color = color_slide[parseInt(point_on_canvas)];

        fill_pixel_at(current_color[0], current_color[1], current_color[2], i, 0, 1, 20);
        
        point_on_canvas += toAddToPick;
    }

    ctx.fillStyle = "black";
    ctx.fillRect(0, 20, currentDim, 1);
}


function fillUnderSide(r, g, b) {
    let to_light_vec = distance_to_val(r, g, b, 255);

    let color_box_size = currentDim / 20;

    for (let x = 0; x < 20; x++) {
        for (let y = 0; y < 20; y++) {
            
            let red_to_light = (to_light_vec[0] / 19) * y;
            let green_to_light = (to_light_vec[1] / 19) * y;
            let to_dark_vec = (to_light_vec[2] / 19) * y;

            let sum_light_r = r + red_to_light;
            let sum_light_g = g + green_to_light;
            let sum_light_b = b + to_dark_vec;

            to_dark_vec = distance_to_val(sum_light_r, sum_light_g, sum_light_b, 0);

            sum_light_r -= (to_dark_vec[0] / 19) * x;
            sum_light_g -= (to_dark_vec[1] / 19) * x;
            sum_light_b -= (to_dark_vec[2] / 19) * x;




            fill_pixel_at(sum_light_r, sum_light_g, sum_light_b, color_box_size * x, color_box_size * y + 21, color_box_size + 2, color_box_size + 2);
        }
    }
}


function fill_pixel_at(r, g, b, x, y, size_x, size_y) {
    let colorString = rgbToString(r,g,b);
    ctx.fillStyle = colorString;
    ctx.fillRect(x, y, size_x, size_y);
}


function distance_to_val(r, g, b, to) {
    return [always_pos(to - r), always_pos(to - g), always_pos(to - b)];
}

function always_pos(val) {
    return val < 0 ? -1 * val : val;
}

//events

function showHover(event){

}

function selectColorFromGrid(event){
    let box = colorPickerInstance.getBoundingClientRect();

    let x = Math.round(event.clientX - box.left);
    let y = Math.round(event.clientY - box.top);

    let pixel_picked = ctx.getImageData(x, y, 1, 1).data;

    currentColor.set([pixel_picked[0], pixel_picked[1], pixel_picked[2]]);

    if (y < 20){fillUnderSide(pixel_picked[0], pixel_picked[1], pixel_picked[2]);}



}

const color_sub = currentColor.subscribe(value => {

    if (safeToUpdate){
        updateColorPreview();
        pickingFromCanvas.set(false);
    }

	});

function startPickingFromCanvas(){
    pickingFromCanvas.set(true);
}

onDestroy(color_sub);

</script>

<svelte:window on:resize={resizeToHolder}/>

<div class="sideBar" bind:this={sideBar}>

    <h4>Brush size: {$brushSize} px</h4>

    <div class="buttonGrid">
        <button on:click={() => {updateSize(1)}}>1</button>
        <button on:click={() => {updateSize(2)}}>2</button>
        <button on:click={() => {updateSize(3)}}>3</button>
        <button on:click={() => {updateSize(5)}}>5</button>
        <button on:click={() => {updateSize(10)}}>10</button>
        <button on:click={() => {updateSize(15)}}>15</button>
        <button on:click={() => {updateSize(20)}}>20</button>
        <button on:click={() => {updateSize(30)}}>30</button>
        <button on:click={() => {updateSize(50)}}>50</button>
    </div>

    <!-- <h4>Opacity: {$opacity}%</h4>


    <div class="buttonGrid" id="sliderHolder">
        <br>
        <input type="range" min="1" max="100" value="100" class="opacitySlide" on:input={updateOpacity} bind:this={sliderInst}>
    </div> -->

    <div class="colorBar">
        <h4>Color:</h4><div class="colorShowcase" bind:this={colorPreview}></div>
    </div>

    
    <button on:click={startPickingFromCanvas}>Pick color from canvas</button>

    <canvas width="300" height="300" bind:this={colorPickerInstance} class="colorPicker"
    on:pointermove={showHover} 
    on:pointerdown={selectColorFromGrid}
    >

    </canvas>
</div>


<style>
    .sideBar{
        width: 15%;
        padding: 3px;
        overflow: hidden;
    }

    .sideBar h4{
        margin: 0px;
    }


    .opacitySlide {
        -webkit-appearance: none;
        width: 100%;
        height: 25px;
        background: white;
        outline: none;
        opacity: 0.7;
        -webkit-transition: .2s;
        transition: opacity .2s;
    }


    .opacitySlide:hover {
        opacity: 1;
    }

    .opacitySlide::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 25px;
        height: 25px;
		background-color: rgb(206 135 69);
        cursor: pointer;
    }

    .opacitySlide::-moz-range-thumb {
        width: 25px;
        height: 25px;
		background-color: rgb(206 135 69);
        cursor: pointer;
    }

    .colorPicker{
        border: 1px solid black;
        cursor: pointer;
    }

    .colorBar{
        display: flex;
    }
    .colorShowcase{
        margin-left: 5px;
        height: 15px;
        width: 15px;
        border: 1px solid black;
    }


</style>